<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js"
      :controls="controls"
      :id="`videoStream${playerId}`"
    ></video>
  </div>
</template>

<script>
import mpegts from 'mpegts.js'

export default {
  name: 'FlvPlayer',
  props: {
    src: {
      type: String,
    },
    playerId: {
      type: String,
      default: '',
    },
    controls: {
      type: Boolean,
      default: false,
    },
    isRecording: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String, // stream OR playback
      required: true,
    },
  },
  data() {
    return {
      player: null,
      flv: null,
      isRecordingLocal: false,
      arrayRecord: [],

      mediaRecorder: null,
      recordedChunks: [],
      recordedBlob: null,
      supportedType: '',
      attemptsStaticticInfo: 0,
    }
  },
  async mounted() {
    if (this.src != '' && this.src != null) {
      if (this.type === 'stream') {
        await this.$emit('requestOnlineCommand')
      }
      this.initialize()
    }
  },
  destroyed() {
    if (this.flv && this.type === 'playback') {
      this.flv.destroy()
    }
    if (this.flv && this.type === 'stream') {
      this.$emit('destroyed', this.playerId, this.flv)
    }
  },
  methods: {
    initialize() {
      if (mpegts.isSupported()) {
        if (this.type === 'playback') {
          this.$store.commit('vehicle/setFrameReceived', null)
          this.$store.commit('vehicle/setCurrentFps', null)
        }
        this.attemptsStaticticInfo = 0

        this.player = this.$refs.videoPlayer
        this.flv = mpegts.createPlayer(
          {
            type: 'flv',
            url: this.src,
            isLive: true,
            // duration: 60000,
          },
          {
            enableWorker: true,
            // enableStashBuffer: false,
            //  accurateSeek: true
          }
        )
        this.flv.attachMediaElement(this.player)
        this.flv.load()

        this.flv.on(mpegts.Events.STATISTICS_INFO, async (data) => {
          this.attemptsStaticticInfo++
          this.$store.commit('vehicle/setFrameReceived', data.decodedFrames)
          await this.$nextTick()
          // stats contains the bandwidth information
          const currentKBps = data.speed // Convert from Bytes/s to KB/s
          this.$emit('loadeddata', data, currentKBps.toFixed(2))
          if (this.attemptsStaticticInfo === 1) {
            if (this.type === 'stream') {
              this.$emit('ready')
              this.$emit('receiveStatisticInfo')
            }
            if (this.type === 'playback') {
              this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
              this.$emit('ready')
            }
            this.$forceUpdate()
          }
        })

        this.flv.play()

        this.flv.on(mpegts.Events.MEDIA_INFO, (data) => {
          this.$store.commit('vehicle/setCurrentFps', data.fps)
        })

        this.flv.on(mpegts.Events.METADATA_ARRIVED, () => {
          this.$emit('ready')
        })

        this.flv.on(mpegts.Events.ERROR, () => {
          this.$emit('error')
          this.attemptsStaticticInfo = 0
        })
      }
    },
  },
}
</script>
